
let helpers = {

  mapField(field) {
    if (field == 'completion_criteria'){
      return 'completion_criterion';
    }
    if (field == 'attachments') {
      return 'attachment';
    }
    else{
      return field;
    }
  },

  mapRelationship(field, relationship, included, filtering) {
    function findInIncluded(field, relationship, included, filtering) {
      if (relationship.data) {
        for (let i = 0; i < included.length; i++) {
          const inc = included[i];
          if (inc.id == relationship.data.id && inc.type == relationship.data.type) {
            return inc;
          }
        }
      }
      else {
        for (let i = 0; i < included.length; i++) {
          const inc = included[i];
          if (inc.id == relationship.id && inc.type == field) {
            return inc;
          }
        }
      }
      return null;
    }
    if (Array.isArray(relationship.data)) {
      return helpers.mapArray(relationship.data, included, true);
    }
    else {
      if (!filtering || (filtering && filtering.fields[field])) {
        if (included) {
          let inc = findInIncluded(helpers.mapField(field), relationship, included, filtering);
          if (inc) {
            if (inc.attributes) {
              if (!inc.attributes.id) {
                inc.attributes.id = parseInt(inc.id, 10);
              }
              return helpers.mapRecord(inc, included);
            }
          }
        }
      }
    }
    return null;
  },

  mapRecord(jsonItem, included, filtering) {
    let record = {};
    if (jsonItem.attributes) {
      for (let f1 in jsonItem.attributes) {
        if (f1) {
          record[f1] = jsonItem.attributes[f1];
        }
      }
    }
    if (jsonItem.relationships) {
      for (let f2 in jsonItem.relationships) {
        if (f2) {
        
          const relationship = helpers.mapRelationship(f2, jsonItem.relationships[f2], included, filtering);
          if (relationship) {
            record[f2] = relationship;
          }
        }
      }
    }
    return record;
  },

  mapArray(jsonArray, included, isRelation, filtering) {
    let array = jsonArray.map(item => {
      const dataType = typeof (item);
      if (dataType == 'object') {
        if (isRelation) {
          const record = helpers.mapRelationship(item.type, item, included, filtering);
          return record;
        }
        else {
          const record = helpers.mapRecord(item, included, filtering);
          return record;
        }
      }
      else if (Array.isArray(item)) {
        const array = helpers.mapArray(item, included, isRelation, filtering);
        return array;
      }
      else {
        return {};
      }
    });
    return array.filter(item => item != null);
  },
  
  mapApiJson(json, filtering) {
    if (json && json.data) {
      const dataType = typeof(json.data);
      if (Array.isArray(json.data)) {
        const array = helpers.mapArray(json.data, json.included, false, filtering);
        return array;
      }
      else if (dataType == 'object') {
        const record = helpers.mapRecord(json.data, json.included, filtering);
        return record;
      }
    }
  },

  validateEmail(mail) {  
    if (/^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail)) {
      return true;
    }  
    return false;
  },

  handleFlattenDirectories(directory, arr) {
    for (var id in directory) {
      if (id) {
        arr.push(directory[id]);
        if (directory[id].directories && directory[id].directories.length) {
          helpers.handleFlattenDirectories(directory[id].directories, arr);
        }
      }
    }
    return arr;
  },

  removeDuplicates(array) {
    const foundIds = new Set();
    return array.filter(entry => {
      const id = entry && entry.id ? entry.id : entry;
      if (id && !foundIds.has(id)) {
        foundIds.add(id);
        return true;
      }
      else return false;
    });
  },

  mergeArrays(array1, array2) {
    let newArray = array2 && array2.length > 0 ? (array1 && array1.length > 0 ? array1.concat(array2) : array2) : (array1 ? array1 : []);
    return helpers.removeDuplicates(newArray);
  },

  isEmpty(obj) {
    if (!obj) {
      return true;
    }
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
        return false;
    }
    return true;
  },

  convertNumbersToAbbr(number,decimal) {
    //if the number is greater than 1000, return an abbreviated number (1000000 -> 1M)
    if (number < 1000) {
      return number;
    }
    let numLength = ('' + number).length; 
    decimal = Math.pow (10, decimal);
    
    numLength -= numLength%3;

    return Math.round(number * decimal / Math.pow(10, numLength)) / decimal + ' kMGTPE'[numLength / 3];
  },

  isUserOnIe() {
    // source: https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    if (msie > 0) {
      // IE 10 or older
      return (parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10) > 0);
    }
    else if (trident > 0) {
      // IE 11 
      const rv = ua.indexOf('rv:');
      return (parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) > 0);
    }
    else return false;
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/helpers/misc-functions.js